import {
    instance as axios,
    setJwtToken,
    // setMultiPartHeader,
  } from "../../config/axiosInstance";
  
  // User List
  export const changePasswordAPi = async (data) => {
    return await axios.put("admin/auth/change",data, setJwtToken());
  };